/**
 * VideoBlock (inline mode)
 * ======================================
 * - markup: js-videoblock (wrapper), js-videoblock-video (pre-rendered <video>, preloading in
 *   the background so it's ready to play instantly), js-videoblock-play (play button)
 * - on click: unmutes/plays the already-loaded video and crossfades it in via CSS (.is-playing)
 */

const WIDGET = '.js-videoblock';
const PLAY_BTN = '.js-videoblock-play';
const VIDEO = '.js-videoblock-video';
const PLAYING_CLASS = 'is-playing';

class VideoBlock {
  constructor() {
    document.querySelectorAll(WIDGET).forEach((widget) => {
      const btn = widget.querySelector(PLAY_BTN);
      const video = widget.querySelector(VIDEO);

      if (!btn || !video) return;

      btn.addEventListener('click', () => {
        video.muted = false;
        widget.classList.add(PLAYING_CLASS);
        video.play();
      }, { once: true });
    });
  }
}

new VideoBlock();
